var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ckeditor',{staticClass:"my-6",attrs:{"editor":_vm.editor,"config":_vm.editorConfig,"value":_vm.value,"outlined":"","dense":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }